import { styled } from 'linaria/react';

export const mdRenderers = {
  p: styled.p`
    margin: 0 0 var(--space-100);
    font-weight: 400;
    font-size: 16px;
    font-style: normal;
    line-height: 24px;
    color: var(--text-primary);
  `,
  li: styled.li`
    margin-top: var(--space-100);
    margin-bottom: var(--space-100);
    font-size: 16px;
  `,
  h2: styled.h3`
    font-size: 26px;
    line-height: 32px;
  `,
  h3: styled.h3`
    font-size: 20px;
    line-height: 26px;
  `,
  a: styled.a`
    font-size: 1em;
    color: var(--brand-dark);
    &:not(:has(img)) {
      text-decoration: underline;
      transition: 0.3s;
      &:hover {
        color: var(--control-hover-accent);
      }
    }
  `,
};
